import React from 'react';
import { IonIcon } from '@ionic/react';
import { checkmarkCircle, closeCircle, timeOutline } from 'ionicons/icons';
import './OutputPanel.css';

/**
 * OutputPanel Component
 * Displays code execution results
 */
function OutputPanel({
  output = '',
  error = null,
  success = true,
  executionTime = null,
  visible = true
}) {
  if (!visible) return null;

  const hasOutput = output || error;

  return (
    <div className={`output-panel ${success ? 'success' : 'error'}`}>
      <div className="output-header">
        <div className="output-status">
          <IonIcon 
            icon={success ? checkmarkCircle : closeCircle} 
            className={`status-icon ${success ? 'success' : 'error'}`}
          />
          <span>{success ? 'Output' : 'Error'}</span>
        </div>
        {executionTime !== null && (
          <div className="execution-time">
            <IonIcon icon={timeOutline} />
            <span>{executionTime}ms</span>
          </div>
        )}
      </div>
      
      <div className="output-body">
        {hasOutput ? (
          <pre className="output-content">
            {error || output}
          </pre>
        ) : (
          <div className="output-empty">
            No output
          </div>
        )}
      </div>
    </div>
  );
}

export default OutputPanel;